<template>
  <div class="dashboard">
    <el-row :gutter="20">
      <el-col :span="6">
        <el-card>
          <div slot="header"><span>总学生数</span></div>
          <div class="stat-value">{{ stats.total_students }}</div>
        </el-card>
      </el-col>
      <el-col :span="6">
        <el-card>
          <div slot="header"><span>今日活跃</span></div>
          <div class="stat-value">{{ stats.active_today }}</div>
        </el-card>
      </el-col>
      <el-col :span="6">
        <el-card>
          <div slot="header"><span>累计答题</span></div>
          <div class="stat-value">{{ stats.total_questions_answered }}</div>
        </el-card>
      </el-col>
      <el-col :span="6">
        <el-card>
          <div slot="header"><span>平均通过率</span></div>
          <div class="stat-value">{{ stats.pass_rate_avg * 100 }}%</div>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import api from '@/api';

export default {
  data() {
    return {
      stats: {
        total_students: 0,
        active_today: 0,
        total_questions_answered: 0,
        pass_rate_avg: 0
      }
    };
  },
  created() {
    this.fetchStats();
  },
  methods: {
    async fetchStats() {
      try {
        this.stats = await api.getDashboardStats();
      } catch (e) {
        console.error(e);
      }
    }
  }
};
</script>

<style scoped>
.dashboard {
  padding: 20px;
}
.stat-value {
  font-size: 24px;
  font-weight: bold;
  text-align: center;
}
</style>
